class TabPanel {
  constructor(settings) {
    this.container = settings.container;
    this.item = settings.item;
    this.mediaQuery = settings.mediaQuery;
    this.tabResetEvent = null;
    this.trigger = settings.trigger;
    this.observer = null;
  }
  bindEvents() {
    if (this.trigger) this.trigger.addEventListener('click', this.resetState.bind(this));
  }
  resetState() {
    this.item.hidden = true;
    this.container.dispatchEvent(this.tabResetEvent);
  }
  setState(event) {
    this.observer.observe(this.item, { attributes: true, childList: false, subtree: false });
    this.item.hidden = event.detail.getAttribute('aria-controls') !== this.item.id;
  }
  mutationCallback() {
    this.observer.disconnect();
  }
  init() {
    this.tabResetEvent = new CustomEvent('tabReset');
    this.container.addEventListener('tabChange', this.setState.bind(this));
    this.bindEvents();
    this.observer = new MutationObserver(this.mutationCallback.bind(this));
  }
}

export default TabPanel;
